<template>
	<TwoPartsTreeBlock v-on="$listeners" :isChosen="isChosen" :class="{ 'portal-tree-block': Boolean(portalAuthText) }">
		<template #first-part>
			<FlowTreeActionBlock
				disabled
				:blockData="{ service: 'some-value', node_title: toolPlacement }"
				:appData="{ service_slug: toolPlacementIcon }"
				:actionData="{}"
				hideStatus
			/>
		</template>
		<template #second-part>
			<span class="text-overflow-ellipsis">
				<v-icon v-if="toolIcon" class="pr-1"> {{ toolIcon }} </v-icon>{{ toolTitle }}
			</span>
			<Col>
				<div v-if="portalAuthText" class="portal-auth-preview-container">
					<PortalAuthRequestCode class="portal-auth-preview" :requestCodeText="portalAuthText" />
				</div>
			</Col>
		</template>
	</TwoPartsTreeBlock>
</template>

<script>
import FlowTreeActionBlock from './FlowTreeActionBlock.vue';
import TwoPartsTreeBlock from './TwoPartsTreeBlock.vue';
import PortalAuthRequestCode from '@/views/FlowRun/PortalAuthRequestCode.vue';

export default {
	name: 'ToolPlacementTreeBlock',
	props: {
		isChosen: { type: Boolean },
		toolPlacement: { type: String },
		toolPlacementIcon: { type: String },
		toolTitle: { type: String },
		toolIcon: { type: String },
		portalAuthText: { type: String },
	},
	components: { TwoPartsTreeBlock, FlowTreeActionBlock, PortalAuthRequestCode },
};
</script>

<style lang="scss" scoped>
.portal-auth-preview {
	width: 100%;
	background-image: url('../../../assets/png/browser-bg.png');
	background-size: 100% 100%;
	padding: 0 !important;
	::v-deep {
		.slot-card {
			scale: 0.4;
			min-width: 0;
			pointer-events: none;
			margin-top: -83px;
			margin-bottom: -89px;
			p {
				white-space: normal;
			}
		}
		.slot-title {
			white-space: normal;
		}
	}
}
::v-deep {
	.ui-element-container {
		overflow: hidden;
		margin: 0;
		.ui-element {
			padding: 7px 0 !important;
		}
	}
}
.portal-tree-block {
	::v-deep {
		.ui-element {
			display: block !important;
		}
	}
}

//import BrowserBackground from '@/assets/icons/browser-bg.png';
</style>
